import { render, staticRenderFns } from "./KgjtWebsiteProduct.vue?vue&type=template&id=ed95c38a&scoped=true&"
import script from "./KgjtWebsiteProduct.vue?vue&type=script&lang=js&"
export * from "./KgjtWebsiteProduct.vue?vue&type=script&lang=js&"
import style0 from "./KgjtWebsiteProduct.vue?vue&type=style&index=0&id=ed95c38a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed95c38a",
  null
  
)

export default component.exports